import { LedgerQueryParams, LedgerDataArray, LedgerModel } from '@app/interfaces/ledger';
import { axiosApi } from './axios.api';
import { apiErrorMessage } from './ApiError';

const url = `/api/ledgers`;

export const getLedgersApi = async (params?: LedgerQueryParams): Promise<LedgerDataArray | undefined> => {
  try {
    const response = await axiosApi.get<LedgerDataArray>(url, { params });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const getLedgerApi = async (ledgerId: number): Promise<LedgerModel | undefined> => {
  try {
    const response = await axiosApi.get(`${url}/${ledgerId}`);
    const { data } = response.data;
    return data.attributes;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const createLedgerApi = async (data: LedgerModel) => {
  try {
    const response = await axiosApi.post(url, data);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const updateLedgerApi = async (ledgerId: number, formData: LedgerModel) => {
  try {
    const response = await axiosApi.put(`${url}/${ledgerId}`, formData);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const deleteLedgerApi = async (ledgerId: number) => {
  try {
    const response = await axiosApi.delete(`${url}/${ledgerId}`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const revertLedgerApi = async (ledgerId: number) => {
  try {
    const response = await axiosApi.post(`${url}/${ledgerId}/revert`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
    throw error;
  }
};

export const getLedgerChartDataApi = async (
  fromDate: string,
  toDate: string,
  groupBy: 'day' | 'month' | 'quarter',
): Promise<any> => {
  try {
    const response = await axiosApi.get(`${url}/chart_data`, {
      params: { from_date: fromDate, to_date: toDate, group_by: groupBy },
    });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const getLedgerStatisticsApi = async (fromDate?: string, toDate?: string): Promise<any> => {
  try {
    const response = await axiosApi.get(`${url}/statistics`, {
      params: {
        ...(fromDate && { from_date: fromDate }),
        ...(toDate && { to_date: toDate }),
      },
    });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const exportLedgerApi = async (params?: string) => {
  try {
    const response = await axiosApi.get(`${url}/export`, { params, responseType: 'blob' });

    const newUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = newUrl;
    link.setAttribute('download', `ledgers.xlsx`);
    document.body.appendChild(link);
    link.click();
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const getActivitiesApi = async (params: string) => {
  try {
    const response = await axiosApi.get(`${url}/activities`, { params });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const getLedgerBalance = async () => {
  try {
    const response = await axiosApi.get(`${url}/fund_balance`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};
